import gql from "graphql-tag";



export const DEL_RECOGNIZE = gql`
mutation RemoveReconocimientoMural($id_reconocimiento: Int!) {
  RemoveReconocimientoMural(id_reconocimiento: $id_reconocimiento) {
    id_reconocimiento,
      reconocidos {
        id_usuario,
        primer_nombre
      }
  }
}
`
export const ADD_RECOGNIZE = gql`
  mutation AgregarReconocimientoMural(
    $id_tipo_reconocimiento: Int!
    $reconocido: UsarioExternoParaReconocer!
    $valor: ValorParaReconocer
    $sucursal: SucursalParaReconocer
  ) {
    AgregarReconocimientoMural(
      id_tipo_reconocimiento: $id_tipo_reconocimiento
      reconocido: $reconocido
      valor: $valor
      sucursal: $sucursal
    ) {
      id_reconocimiento
      fecha_creacion
      valor_comportamiento {
        id_valor_comportamiento
        valor {
          id_valor
          nombre_valor
        }
        comportamiento {
          id_comportamiento
          nombre_comportamiento
        }
      }
      reconocidos {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        sucursal {
          id_sucursal
          nombre_sucursal
        }
      }
    }
  }
`;